import DashboardSwitcher from './DashboardSwitcher.jsx';
import { SportsTickerCard } from './SportsTicker.jsx';
import usePolling from '../hooks/usePolling.js';
import { getSportsTicker } from '../api/client.js';

const CENTIER_LOGO =
  'https://www.centier.com/images/default-source/content-images/centier_bank_4c_adjustedhorizontal.svg';

// Sidebar for the Upgrade Weekend analytics command center. Logo + the shared
// dashboard tabs + a short branded caption. Page-scope controls live in the
// page body (they change per-view), so the sidebar stays a stable nav frame.
// The empty lower area hosts the Bears ticker card (this sidebar has the room).
export default function AnalyticsSidebar() {
  const { data, loading } = usePolling(getSportsTicker, 60000);

  return (
    <aside className="sidebar">
      <div className="sidebar__header">
        <img className="sidebar__logo" src={CENTIER_LOGO} alt="Centier Bank" />
      </div>

      <DashboardSwitcher />

      <div className="sidebar__scroll">
        <div className="sidebar__section">
          <SportsTickerCard data={data} loading={loading} />
        </div>
      </div>
    </aside>
  );
}
